import {Component, Inject} from '@angular/core';
import {Router} from '@angular/router';
import {
  v1_pulseContextServiceName,
  IPulseContextService
} from '@app/v1_integration';

import {environment} from 'environments/environment';
import {LoggerService, AuthService} from '@core/services';
import {PlatformLocation, LocationChangeEvent} from '@angular/common';

@Component({
  selector: 'idp2-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = '';
  public isCollapsed = false;

  constructor(
    @Inject(v1_pulseContextServiceName)
    private pulseContext: IPulseContextService,
    private logger: LoggerService,
    private authService: AuthService
  ) {
    // this.title = 'app: ' + StringConst.Err_Not_Implemented + Enums.RecordStateType.Active + "<br>Logged in = " + pulseContext.actingAsUserId;
    // logger.logInfo("test test", null, "", true);
    // logger.logError("Oh No!!!")
    // this.logger.logInfo("CompareComponent ngOnInit", null, "", true);
  }
  onActivate(e) {
    window.scroll(0, 0);
  }
}
